import React from 'react'
import { MeasurandData } from '../../../../stations/types/stations.types';
import useChargingSessionAnalysis from '../../../hooks/useChargingSessionAnalysis';
import ChartLoaderView from '../../../../../common/components/molecule/Chart/ChartLoaderView/ChartLoaderView';
import { AxiosError } from 'axios';
import { extractAxoisErrorsMessage } from '../../../../errorHandler/utils/errors.utils';
import { createListPointRaw } from '../../../../../common/analysis/utils/graph.utils';
import ChartLineView from '../../../../../common/components/molecule/Chart/ChartLineView/ChartLineView';
import BarCharView from '../../../../../common/components/molecule/Chart/BarCharView/BarCharView';



export default function ChargingSessionChart({measurand, chargingSessionId, 
    label, 
    unit, 
    convert, 
    chartType = "line"
}: { measurand: MeasurandData,  chargingSessionId?: string, label?: string, unit?: string, convert?: (value: number) => number, chartType?: "line" | "bar" }) {
  const { dataQuery} = useChargingSessionAnalysis(measurand,  chargingSessionId);

  if (dataQuery.isLoading) {
    return <ChartLoaderView />;
  }
  if (dataQuery.isError && dataQuery.error) {
    const error = dataQuery.error as AxiosError;

    const message = extractAxoisErrorsMessage(error);
    

    if (message.includes("no data found")) {
      return (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            color: "gray",
          }}
        >
          <p>Aucune donnée trouvée</p>{" "}
        </div>
      );
    }

    return <div>Error occure {error.message}</div>;
  }

  const dataChart = createListPointRaw(dataQuery.data || [])


  if (chartType === "line") {
    return (
      <ChartLineView
        xAxisData={dataChart.listx.map((item) => new Date(item))}
        data={dataChart.listValue.map((item) => convert ? convert(item) : item)}
        label={label}
        unit={unit}
        
      />
    );
  }

  if (chartType === "bar") {
       return (
      <BarCharView
        xAxisData={dataChart.listx.map((item) => new Date(item))}
        data={dataChart.listValue.map((item) => convert ? convert(item) : item)}
        label={label}
        unit={unit}
      />
    );
  }

  return (
    <BarCharView
      xAxisData={dataChart.listx.map((item) => new Date(item))}
      data={dataChart.listValue.map((item) => convert ? convert(item) : item)}
      label={label}
      unit= {unit}
    />
  );
}